import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Input,
  Label,
  FormGroup,
  Form,
  Row,
  Col,
  Button,
  FormFeedback,
} from 'reactstrap';
import HelpIcon from '../search-components/HelpIcon';
import { groupBy } from '../dataTransform';
import { getSimple } from '../actions';
import NoDataAlert from '../search-components/NoDataAlert';

const help = {
  input: {
    name: 'Įrašykite bet kokį žodį ar žodžių junginį (dviejų arba trijų žodžių). Kaip paieškos rezultatas bus pateiktos visos žodžių junginio formos.',
    value: 'word',
  },
  checkbox: {
    name: 'Įrašykite tikslią žodžio formą arba tikslią žodžių junginio formą (dviejų arba trijų žodžių). Kaip paieškos rezultatas bus pateikti žodžių junginiai tik su šia forma.',
    value: 'exact',
  },
};

class SimpleInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mwe: '',
      exact: false,
      validate: {
        mweValid: true,
      },
      noResults: false,
    };

    this.handleInput = this.handleInput.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setNoResults = this.setNoResults.bind(this);
  }

  handleInput = (event) => {
    this.setState({ mwe: event.target.value })
  };
  handleCheckbox = (event) => {
    this.setState({ exact: event.target.checked })
  };
  setNoResults = (value) => {
    this.setState({ noResults: value })
  };

  prepareData(data, count, form_count) {
    let groupedData = groupBy(data);
    this.props.onLemaAdded(groupedData, count, form_count);
  };

  validateMwe(e) {
    const wordsRex = /^([\wąčęėįšųūžĄČĘĖĮŠŲŪŽ]+\s?)([\wąčęėįšųūžĄČĘĖĮŠŲŪŽ]+\s)?([\wąčęėįšųūžĄČĘĖĮŠŲŪŽ]+)?\s?$/;
    const { validate } = this.state;
    validate.mweValid = wordsRex.test(e.target.value);
    this.setState({ validate });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleSimpleSetState('loading', true);
    this.props.clearLemaData();
    getSimple(this.state.mwe, this.state.exact, 1, this.props.sort)
      .then(response => {
        if (response.data.count === 0) {
          this.setNoResults(true);
        } else {
          this.props.handleSimpleSetState('firstRequestDone', true);
          this.setNoResults(false);
          this.prepareData(response.data.mwe, response.data.count, response.data.form_count);
          this.props.saveRequest(
            {
              mwe: this.state.mwe.toLowerCase(),
              exact: this.state.exact,
            });
        }
      })
      .catch(error => {
        console.log(error);
      })
      .then(() => {
        this.props.handleSimpleSetState('page', 1);
        this.props.handleSimpleSetState('loading', false);
      });
  }

  render() {
    return (
      <div className="m-2">
        <Row>
          <Col sm={{ size: 10, offset: 1 }} md={{ size: 8, offset: 2 }}>
            <Card>
              <CardBody>
                <CardTitle>Paieška</CardTitle>
              </CardBody>
              <Form onSubmit={this.handleSubmit}>
                <FormGroup row className="p-3">
                  <Label for="search" sm="5" size="lg">Ieškomas žodis (junginys) <HelpIcon
                    text={help.input.name} value={help.input.value}/>
                  </Label>
                  <Col sm="7">
                    <Input type="text" value={this.state.mwe}
                           onChange={(e) => {
                             this.validateMwe(e);
                             this.handleInput(e);
                           }}
                           name="search" id="search"
                           bsSize="lg"
                           invalid={!this.state.validate.mweValid}
                    />
                    <FormFeedback>
                      Įveskite vieną žodį arba junginį, sudarytą iš ne daugiau kaip 3 žodžių
                    </FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup check className="m-3">
                  <Label check size="lg">
                    <Input value={this.state.exact} onChange={this.handleCheckbox} name="exact" type="checkbox"/>{' '}
                    Tiksli forma <HelpIcon text={help.checkbox.name} value={help.checkbox.value}/>
                  </Label>
                </FormGroup>
                <br/>
                <Button disabled={!this.state.validate.mweValid || this.state.mwe === ''} block
                        className="search-button">Ieškoti</Button>
              </Form>
            </Card>
          </Col>
        </Row>
        <NoDataAlert noResults={this.state.noResults}/>
      </div>
    );
  }
}

export default SimpleInput;

